import React, { Fragment } from "react";
// import { NavLink } from "react-router-dom";
import "react-notifications/lib/notifications.css";
import { Base_URL } from "../BaseURL";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

function PhiladelphiaMarketingForm(props) {

    function onSubmit(type) {
        return () => {
          switch (type) {
            case "success":
              NotificationManager.success("Successfully Submitted");
              break;
            default:
            case " ":
          }
        };
      }

  return (
    <Fragment>
 <section className="philadelphia_marketing_form">
    <div className="container">
        <h4 className="mb-0">Get Your FREE Digital Marketing Proposal</h4> 
        <h4>Is your <span className="city_name">{props.cityName}</span> business ready to conquer the digital marketplace? Get your FREE digital marketing proposal now and turn your website into a lead generation machine. Fill out this form to start your journey. </h4>
        <form
        className="ecom_form"
        id="philadelphia-form"
        method="POST"
        action={`${Base_URL}/philadelphia-form`}        
        onSubmit={onSubmit("success")}
      >
        <div className="row mb-3">
          <input
            className="from-control"
            type="hidden"
            id="key"
            name="key"
            value={window.location.pathname.slice(1)}
          />
          <div className="col-12 col-sm-12 col-md-6 col-lg-6">
            <input
              type="text"
              id="name"
              name="name"
              className="form-control ecom_name_field"
              placeholder="Name"
              required={true}
            />
          </div>
          <div className="col-12 col-sm-12 col-md-6 col-lg-6">
            <input
              type="email"
              id="email"
              name="email"
              className="form-control ecom_email_field"
              placeholder="Email Address"
              required={true}
            />
          </div>
         
        </div>
        <div className="row mb-3">
        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
            <input
              type="text"
              id="organizationname"
              name="organizationname"
              className="form-control ecom_name_field"
              placeholder="Name Of Organization"
              required={true}
            />
          </div>
          
          <div className="col-12 col-sm-12 col-md-6 col-lg-6">
            <input
              type="text"
              id="subject"
              name="subject"
              className="form-control ecom_url_field"
              placeholder="Business Website"
              required={true}
            />
          </div>
       
        </div>
        <div className="row mb-5">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
           <textarea className="area_text" id="message" name="message" rows="5" cols="8" placeholder="Message" >

           </textarea>
          </div>
          
        </div>
        <NotificationContainer />
        <div className="captcha-btn recaptcha_group">
          {/* <ReCAPTCHA
            sitekey="6LfYM_oUAAAAAAkkme8vL33ls2GEqWhU3ZRCNX4C"
            onChange={onChange}
            className="recaptcha"
            ref={captchaRef}
          /> */}
          <button className="readon submit new">Submit Now</button>
        </div>
      </form>
    </div>
 </section>
    </Fragment>
  );
}

export default PhiladelphiaMarketingForm;
